import {CustomCode} from "./common.model";


export class NotificationType extends CustomCode{
  public static _registered = new Map<string, NotificationType>();
  //
  static EMAIL = new NotificationType('EMAIL');
  static APPLICATION  = new NotificationType('APPLICATION');
  static APPLICATION_AND_EMAIL  = new NotificationType('APPLICATION_AND_EMAIL');
  static NONE  = new NotificationType('NONE');

  static ALL = Array.from(NotificationType._registered.values());

  constructor (code: string) {
    super(code);
    NotificationType._registered.set(code, this);
  }


  static retrieveFromCode(code: string): NotificationType {
    const res = NotificationType._registered.get(code);
    if (!res) {
      console.log('NotificationType can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }

  toTranslateKey():string{
    return 'NOTIFICATION_TYPE_' + this.code;
  }


}
